/**
 * Converts a chromogen only kit to a consumer form state.
 * @return ChromogenKitForm
 */
export var chromogenKitToConsumerFormState = function (catalog, kit) {
    var _a, _b, _c, _d, _e, _f;
    var protocolType;
    var scale;
    var chromogen;
    var presetChromogenScale = (_a = kit.chromogenComponent) === null || _a === void 0 ? void 0 : _a.presetScale;
    protocolType = catalog.proPlatforms.find(function (p) { return p.id === kit.platform.id; });
    scale = (_f = (_d = (_c = (_b = kit.chromogenComponent) === null || _b === void 0 ? void 0 : _b.presetScale) === null || _c === void 0 ? void 0 : _c.units) !== null && _d !== void 0 ? _d : (_e = kit.chromogenComponent) === null || _e === void 0 ? void 0 : _e.customScale) !== null && _f !== void 0 ? _f : catalog.defaultAutomatedProScale;
    chromogen = catalog.proChromogens.chromogens.find(function (c) { var _a, _b; return c.id === ((_b = (_a = kit.chromogenComponent) === null || _a === void 0 ? void 0 : _a.chromogen) === null || _b === void 0 ? void 0 : _b.id); });
    return {
        protocolType: protocolType,
        scale: scale,
        presetChromogenScale: presetChromogenScale,
        chromogen: chromogen,
        errors: [],
        price: undefined,
        priceLoading: false,
        comment: kit.comment
    };
};
//# sourceMappingURL=ChromogenKitToConsumerFormState.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ChromogenKitToConsumerFormState.js
// module id = 596
// module chunks = 0